import { type ILabelsSettingValues } from '~/pages/Settings/Labels/types';

import { ActionKeys } from './constants';

export const fetchLabelSettings = () =>
  <const>{
    type: ActionKeys.FETCH_LABEL_SETTINGS,
  };

export const submitLabelsForm = (formData: ILabelsSettingValues) =>
  <const>{
    payload: {
      formData,
    },
    type: ActionKeys.SAVE_LABEL_SETTINGS,
  };

// TODO: Name is not standard. Rename
export const didSaveLabel = (response) =>
  <const>{
    payload: response,
    type: ActionKeys.SAVE_LABEL_SETTINGS_SUCCESS,
  };

export const fetchLabelSettingsSuccess = (response) =>
  <const>{
    payload: response,
    type: ActionKeys.FETCH_LABEL_SETTINGS_SUCCESS,
  };

export type LabelsSettingsActions =
  | ReturnType<typeof didSaveLabel>
  | ReturnType<typeof fetchLabelSettings>
  | ReturnType<typeof fetchLabelSettingsSuccess>
  | ReturnType<typeof submitLabelsForm>;
